import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import screenfull from 'screenfull';
import { Component, Vue } from 'vue-property-decorator';
var sf = screenfull;
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "isFullscreen", false);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "mounted",
    value: function mounted() {
      if (sf.isEnabled) {
        sf.on('change', this.change);
      }
    }
  }, {
    key: "beforeDestory",
    value: function beforeDestory() {
      if (sf.isEnabled) {
        sf.off('change', this.change);
      }
    }
  }, {
    key: "change",
    value: function change() {
      if (sf.isEnabled) {
        this.isFullscreen = sf.isFullscreen;
      }
    }
  }, {
    key: "click",
    value: function click() {
      if (!sf.isEnabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning'
        });
        return false;
      }
      sf.toggle();
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  name: 'Screenfull'
})], default_1);
export default default_1;